<template>
  <div id="contenedor-editar-catalogo-insumo">
    <v-form v-model="formularioValido" ref="formEditarCatalogoInsumo">
      <v-card>
        <v-card-title class="secondary--text">
          Editar insumo
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            cols="12"
            label="Descripción"
            v-model="insumo.descripcion"
            v-on:keyup.enter="mixActualizarCatalogoInsumo"
          >
          </custom-text-field>
          <v-row>
          <custom-select
            cols="6"
            v-model="insumo.tipo"
            label="Tipo de Insumo"
            :items="itemsTiposInsumos"
            item-text="insumo"
            item-value="value">
          </custom-select>
          <custom-text-field
            cols="6"
            label="Orden"
            v-model.number="insumo.orden"
          >
          </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarCatalogoInsumo"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoInsumos from './mixCatalogoInsumos';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarCatalogoInsumo',
  mixins: [mixCatalogoInsumos],
  props: {
    insumoEditar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      itemsTiposInsumos: [
        { insumo: 'Personal', value: 1 },
        { insumo: 'Maquinaria', value: 2 },
        { insumo: 'Equipo', value: 3 },
      ],
      insumo: {
        tipo: this.insumoEditar.tipo,
        descripcion: this.insumoEditar.descripcion,
        orden: this.insumoEditar.orden,
      },
    };
  },
  methods: {
    cerrar() {
      this.limpiarformulario();
      this.$emit('cerrar');
    },
    limpiarformulario() {
      this.$refs.formEditarCatalogoInsumo.reset();
    },
  },

};
</script>

<style>

</style>
